import type { WorkflowsEditorDomain } from "../context/workflows-editor-config-context";

type ShopLocalePreferences = {
  preferences?: { languages?: string[] } | null;
  trackingPreferences?: {
    availableLocales?: string[] | null;
    notificationsDefaultLocale?: string | null;
  } | null;
};

/** "fr-FR" / "en-US" → "fr" / "en" */
export function toBaseLocale(language: string): string {
  return language.toLowerCase().split("-")[0];
}

/**
 * Locales offered by translatable action fields (ticket title/description…).
 * The return domain follows the customer-portal languages
 * (shop.preferences.languages, "fr-FR" format, reduced to base codes — the
 * runtime resolves ticket texts against the base of returnRequest.lang);
 * tracking keeps the tracking-page locales (already base codes).
 */
export function getDomainLocales(
  shop: ShopLocalePreferences,
  domain: WorkflowsEditorDomain,
): string[] {
  if (domain === "return") {
    const bases = (shop.preferences?.languages ?? []).map(toBaseLocale);
    const deduped = [...new Set(bases)];
    if (deduped.length > 0) return deduped;
  } else {
    const locales = shop.trackingPreferences?.availableLocales;
    if (locales && locales.length > 0) return locales;
  }
  return ["en", "fr"];
}

export function getDomainDefaultLocale(
  shop: ShopLocalePreferences,
  domain: WorkflowsEditorDomain,
): string {
  if (domain === "return") {
    const [first] = shop.preferences?.languages ?? [];
    return first ? toBaseLocale(first) : "en";
  }
  return shop.trackingPreferences?.notificationsDefaultLocale || "en";
}
